import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';

export type ForwardReminderVariables = {
  id: number;
  emails: Array<string>;
};

async function forwardReminderFn(
  axiosInstance: Promise<AxiosInstance>,
  { id, emails }: ForwardReminderVariables,
): Promise<ApiResponse> {
  const instance = await axiosInstance;

  return instance.post(`/payment_requests/${id}/forward`, { emails });
}

export function useForwardReminder() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, ForwardReminderVariables>({
    mutationFn: variables => forwardReminderFn(axiosInstance, variables),
    onSuccess: (_response, { id }) => {
      client.invalidateQueries({ queryKey: ['reminders', String(id)] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    ForwardReminderVariables,
    'forwardReminder'
  >('forwardReminder', mutation);
}
